import { Button, Image, View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import NoRewardImage from "@/assets/images/3d-illus/no-rewards.png";
import { useClientReferralByFiltersQuery } from "@/gqlhooks/client/useClientReferralByFiltersQuery";
import { copyClipboard } from "@/lib/helpers/copy-clipboard";
import { useSharerModalStore } from "@/store/sharer";
import { useState } from "react";

export const ReferralHistoryEmpty = () => {
  const { setOpen } = useSharerModalStore();
  const { code } = useClientReferralByFiltersQuery();

  const [isCopying, setIsCopying] = useState(false);
  const [isSharing, setIsSharing] = useState(false);

  const referralCode = code || "";

  const handleCopyReferralCode = async () => {
    setIsCopying(true);
    try {
      await copyClipboard(referralCode);
    } finally {
      setIsCopying(false);
    }
  };

  const handleShareReferralCode = () => {
    setIsSharing(true);
    try {
      setOpen(true);
    } finally {
      setIsSharing(false);
    }
  };

  return (
    <View className="py-6">
      <View className="flex flex-col items-center gap-2">
        <View className="flex flex-col items-center gap-1">
          <Image
            src={NoRewardImage}
            alt="No Referral"
            width={106}
            height={106}
          />
          <Typography variant="label-sm" color="foreground-default">
            No referrals yet
          </Typography>
          <Typography
            variant="body-sm"
            color="foreground-intermediate"
            className="text-center"
          >
            Invite your friends and earn $15 when they complete their first
            booking.
          </Typography>
        </View>
        <View className="mt-1 flex flex-row items-center gap-2">
          <Button
            variant="secondary"
            color="CTA2"
            size={"md"}
            rounded="full"
            loading={isCopying}
            onClick={handleCopyReferralCode}
            iconAlignment={"end"}
            iconName="copy"
            iconColor="CTA2"
            iconSize={"md"}
          >
            {referralCode}
          </Button>
          <Button
            variant="primary"
            color="CTA"
            size={"md"}
            rounded="full"
            loading={isSharing}
            onClick={handleShareReferralCode}
            iconAlignment={"end"}
            iconName="shareFat"
            iconColor="CTA"
            iconSize={"md"}
          >
            Share
          </Button>
        </View>
      </View>
    </View>
  );
};
